define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/def/Action",
	"csi/def/ViewRef",
	"csi/xml",
	"csi/xml/Query"
], function(declare,lang,Action,ViewRef,xml,Query) {

	return declare(null, {
		// Boolean: optional filters for Material
		//_bForMaterialBOM: false,
		//_bForStyleBOM: false,

		isForMaterialBOM: function(/*Context*/ctx) {
			// summary: determine if need to filter for Materials okay'd to appear on material BOM
			return this._bForMaterialBOM;
		},

		isForStyleBOM: function(/*Context*/ctx) {
			// summary: determine if need to filter for Materials okay'd to appear on style BOM
			return this._bForStyleBOM;
		},

		_addFilters: function(/*Context*/ctx, /*Query*/q) {
			// summary: return filters for selecting materials
			var idFilter;

			if (this.isForMaterialBOM(ctx)) {
				idFilter = "UsableForMaterialBOM";
			} else if (this.isForStyleBOM(ctx)) {
				idFilter = "UsableForStyleBOM";
			} else {
				idFilter = "Usable";
			}

			q.Attr(idFilter, xml.OP_EQUALS, true);
		},

		_getStoreAction: function(/*Context*/ctx, /*Heading*/h, /*Boolean*/bAll) {
			// summary: return action to select material with appropriate filters
			var	q = new Query();

			this._addFilters(ctx, q);

			return lang.mixin(new Action(), {
				m_fixedQuery: q,
				m_viewRef: lang.mixin(new ViewRef(), {
					m_id: "MaterialsView",
					m_url: "centric://APPAREL/Views"
				})
			});
		}
	});
});